export default "__VITE_ASSET__COfgAMcH__"